import {useEffect, useState} from 'react';
import {TCutLists} from 'modules/cut';
import {getCutListTotalDurationInSectcion} from 'lib/playUtils';

/**
 * 편집 관련 안내 문구 표시 hooks
 */

export type TDisplayWarn = {
  sectionIdx: number;
  display: boolean;
};

export default function useEditWarn(
  editMode: string,
  sectionIdx: number,
  sectionNode: any,
  cutLists: TCutLists[][],
) {
  const [displayWarn, setDisplayWarn] = useState({
    sectionIdx: 1,
    display: false,
  });

  useEffect(() => {
    // 웹 편집기에만 관련 안내문구 표시
    if (editMode !== 'web') return;

    const cutDuration = getCutListTotalDurationInSectcion(cutLists[sectionIdx]); // 장면 내의 편집한 전체 시간

    if (!sectionNode[sectionIdx] || cutDuration <= 0) {
      setDisplayWarn({
        sectionIdx: sectionIdx + 1,
        display: true,
      });
    } else {
      setDisplayWarn({
        sectionIdx: 1,
        display: false,
      });
    }
  }, [sectionIdx, sectionNode, cutLists]);

  return displayWarn;
}
